import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  workbooks: [],
  workbook: null,
  calendar: {
    activeDate: null
  },
  chartConfig: {
    trendlineTimeRange: null,
  },
};

export const workbookSlice = createSlice({
  name: "workbook",
  initialState,
  reducers: {
    updateByName: (state, action) => {
      state.workbook[action.payload.name] = action.payload.value;
    },
    loadWorkbook: (state, action) => {
      state.workbook = action.payload;
    },
    clearWorkbook: (state) => {
      state.workbook = null;
    },
    updateCalendar: (state, action) => {
      state.calendar = action.payload;
    },
    updateChartConfigByName: (state, action) => {
      state.chartConfig[action.payload.name] = action.payload.value;
    },
  },
});

export const { updateByName, updateCalendar, loadWorkbook, clearWorkbook, updateChartConfigByName } = workbookSlice.actions;
export default workbookSlice.reducer;
